
declare var window: any

const later = (delay: number, value: any): Promise<Window> => new Promise(resolve => setTimeout(resolve, delay, value));

/**
 * Ignora versiones de iOS y Android
 */
export interface IVersions {
    Ignore(): boolean
}

export class ANDROID implements IVersions {
    private Version: number = Number(window['device'].version.split('.')[0]);
    public Ignore = (): boolean => this.Version <= 7;
}

export class IOS implements IVersions {
    private Version: number = Number(window['device'].version.split('.')[0]);
    public Ignore = (): boolean => this.Version <= 12;
}

export class Browser implements IVersions {
    public Ignore = (): boolean => false;
}

export class VERSIONS {
    public static VersionGames = async (): Promise<IVersions> => {
        const value = await later(300, window);
        const OSName = value['device'] ? value['device'].platform : 'Browser';

        const dictionary: any = {
            iOS: () => new IOS(),
            Android: () => new ANDROID(),
            Browser: () => new Browser()
        };
        return dictionary[OSName]();
    }
}

export const IGNORE = async () => (await VERSIONS.VersionGames()).Ignore();

/**
 * Valida si tiene una versión menor de iOS 15
 */
export class MINORiOS {
    public static isMinor = async (): Promise<boolean> => {
        const value = await later(300, window);
        const OSName = value['device'] ? value['device'].platform : 'Browser';
        const Version: number = Number(window['device'] ? window['device'].version.split('.')[0] : 0);

        const dictionary = {
            iOS: Version < 15,
            Android: false,
            Browser: false
        };

        return dictionary[OSName];
    }
}

export const ISMINOR = async () => await MINORiOS.isMinor();
